import React from 'react';
import { ApiTransaction } from '../api';
import { formatAmount } from '../schema/helper';
import { Popover } from 'react-bootstrap';
import RmsPopover from '../common/popover/RmsPopover';
import TransactionAttributes from './TransactionAttributes';
import './TransactionDetailsPopover.scss';
import { useMe } from '../organisation/useMe';

interface TransactionDetailsPopoverProps {
  transaction?: ApiTransaction;
  showAmount?: boolean;
}

const TransactionDetailsPopover = ({ transaction, showAmount = false }: TransactionDetailsPopoverProps) => {
  if (!transaction) return <span>-</span>;
  const { currentOrganisation } = useMe();
  return (
    <>
      {showAmount && formatAmount(parseFloat(transaction.attributes?.amount || '0'), currentOrganisation?.currency)}
      {showAmount && <span> • </span>}
      <RmsPopover
        overlay={
          <Popover id='transaction-details-popover'>
            <Popover.Body>
              <TransactionAttributes
                transaction={transaction}
                showLinkToTransactionPage={false}
                showLinkToCustomerPage={false}
                showId={true}
              />
            </Popover.Body>
          </Popover>
        }
      >
        <span className='hover-link transaction-id'>{transaction?.id}</span>
      </RmsPopover>
    </>
  );
};

export default TransactionDetailsPopover;
